import { DynamicControl } from '@shared/models/dynamic-form-control.model';

export class DatepickerControl extends DynamicControl<string> {
    controlType = 'datepicker';
    type: 'date';

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
    }
}
